import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import PageTitle from './PageTitle';

const ImportsReportPage = (props) => {
  const {
    match: {
      params: { id: taskId },
    },
    getAction,
  } = props;

  const [currentTask, setCurrentTask] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAction(taskId)).then((data) => setCurrentTask(data));
  }, [dispatch, taskId]);

  return (
    <>
      <PageTitle title="Отчёт" />
      <div className="card">
        <div className="card-body">
          <div className="bootstrap-table">
            <div className="fixed-table-container">
              <div className="fixed-table-body">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>Время</th>
                      <th>Строка</th>
                      <th>Состояние</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTask &&
                      currentTask.processingLog.map((item) => (
                        <tr data-testid="report-row">
                          <td className="font-weight-bolder">{item.time}</td>
                          <td>Строка {item.strNum}</td>
                          <td>{item.event}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportsReportPage;
